import { useGetMyParadiseImage, useGetStrings } from "@app/store/service/cmsService"
import { IframeMessages } from "@app/utils/constants"
import "./MyParadiseBluphoria.css"

export const MyParadiseBluphoria = () => {
	const { data: image } = useGetMyParadiseImage({ type: "bluphoria" })
	const {
		data: { myParadiseOverviewBluphoria },
	} = useGetStrings(undefined, { defaultData: {} })

	return (
		<div
			className="myParadiseBluphoria h-100"
			style={{ backgroundImage: 'url("' + image || "" + '")' }}
			onClick={() => {
				let url = "https://bluphoria.de"
				if (window.self !== window.top) {
					window.parent.postMessage(IframeMessages.openUrl + ";" + url, "*")
				} else {
					window.open(url)
				}
			}}
		>
			<div className="f2 text-center color-fg-white pt-2 px-3">{myParadiseOverviewBluphoria}</div>
			<img src={image || ""} style={{ opacity: 0, width: "100%", height: "auto" }} />
		</div>
	)
}
